// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import {
  DocumentData,
  getFirestore,
  QueryDocumentSnapshot,
  connectFirestoreEmulator,
  enableIndexedDbPersistence,
  enableMultiTabIndexedDbPersistence,
} from "firebase/firestore";
import { getFunctions, connectFunctionsEmulator } from "firebase/functions";
import { getAuth, connectAuthEmulator } from "firebase/auth";
import { getStorage, connectStorageEmulator } from "firebase/storage";
import * as Sentry from "@sentry/vue";

const firebaseConfig = {
  apiKey: "AIzaSyA5toHAzX1O0EK1tnIw9WGUjunvYpQTois",
  authDomain: "intransvoice.firebaseapp.com",
  projectId: "intransvoice",
  storageBucket: "intransvoice.appspot.com",
  messagingSenderId: "680557369550",
  appId: "1:680557369550:web:45acbe38077f7701de189f",
  measurementId: "G-CYCFBB2T8D",
};

// Initialize Firebase
export const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
export const db = getFirestore(app);
export const funcs = getFunctions(app);
export const auth = getAuth(app);
export const storage = getStorage(app);

if (import.meta.env.VITE_USE_FIREBASE_EMULATOR === "true") {
  connectFunctionsEmulator(funcs, "localhost", 5001);
  connectFirestoreEmulator(db, "localhost", 6101);
  connectAuthEmulator(auth, "http://localhost:9099");
  connectStorageEmulator(storage, "localhost", 9199);
} else {
  
  // Enable offline persistence for better reliability
  // Fixes INTRANSVOICE-98 (connection failures) and INTRANSVOICE-97 (abort errors)
  enableMultiTabIndexedDbPersistence(db)
    .catch((err) => {
      if (err.code === 'failed-precondition') {
        // Multiple tabs open, persistence can only be enabled in one tab at a time
        console.warn('Firestore persistence failed: Multiple tabs open');
        Sentry.captureMessage('Firestore persistence failed: Multiple tabs', 'warning');
      } else if (err.code === 'unimplemented') {
        // The current browser doesn't support persistence
        console.warn('Firestore persistence not available in this browser');
      } else {
        // Fallback to single-tab persistence
        enableIndexedDbPersistence(db)
          .catch((persistErr) => {
            if (persistErr.code === 'unimplemented') {
              console.warn('IndexedDB not supported in this browser');
            } else {
              console.error('Error enabling Firestore persistence:', persistErr);
              Sentry.captureException(persistErr);
            }
          });
      }
    });
}


export const converter = <T>() => ({
  toFirestore: (data: any) => data,
  fromFirestore: (snap: QueryDocumentSnapshot) => {
    return { id: snap.id, ...snap.data() } as T;
  },
});
